import React, { useState, useEffect } from 'react';
import { useTranslation } from '../context/TranslationContext';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  duration?: number; // Duration in seconds, default 4
}

const SuccessModal: React.FC<SuccessModalProps> = ({ 
  isOpen, 
  onClose, 
  message, 
  duration = 4 
}) => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(duration);

  useEffect(() => {
    if (isOpen) {
      setCountdown(duration);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            onClose();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isOpen, duration, onClose]);

  console.log('🔍 SuccessModal render - isOpen:', isOpen, 'message:', message);
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(4px)',
          zIndex: 9998,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={onClose}
      >
        {/* Modal */}
        <div 
          style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '32px',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            position: 'relative',
            zIndex: 9999,
            textAlign: 'center'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Success Icon */}
          <div style={{ marginBottom: '24px' }}>
            <div 
              style={{
                width: '64px',
                height: '64px',
                backgroundColor: '#dcfce7',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto'
              }}
            >
              <svg 
                style={{ width: '32px', height: '32px', color: '#16a34a' }}
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M5 13l4 4L19 7" 
                />
              </svg>
            </div>
          </div>

          {/* Message */}
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              fontSize: '20px', 
              fontWeight: 600, 
              color: '#111827', 
              marginBottom: '8px',
              margin: '0 0 8px 0'
            }}>
              {t('common.success')}
            </h3>
            <p style={{ color: '#6b7280', margin: 0 }}>
              {message}
            </p>
          </div>

          {/* Countdown */}
          <div>
            <div 
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '48px',
                height: '48px',
                backgroundColor: '#dbeafe',
                borderRadius: '50%',
                marginBottom: '8px'
              }}
            >
              <span style={{ 
                fontSize: '18px', 
                fontWeight: 600, 
                color: '#2563eb' 
              }}>
                {countdown}
              </span>
            </div>
           
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              color: '#9ca3af',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '4px',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#6b7280';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#9ca3af';
            }}
          >
            <svg style={{ width: '24px', height: '24px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default SuccessModal;
